import type { SVGProps } from 'react';
const SvgVibration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#vibration_svg__a)">
      <path
        fill="currentColor"
        d="M0 15h2V9H0v6Zm3 2h2V7H3v10Zm19-8v6h2V9h-2Zm-3 8h2V7h-2v10ZM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5ZM16 19H8V5h8v14Z"
      />
    </g>
    <defs>
      <clipPath id="vibration_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVibration;
